import { render } from "./DownloadVpass.vue?vue&type=template&id=163beb5f"
import script from "./DownloadVpass.vue?vue&type=script&lang=js"
export * from "./DownloadVpass.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__